<script>
import meta from "../utils/meta"

export default {
  name: 'logo',
  props: {
    large: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      meta
    }
  }
}
</script>

<template>
  <div class="logo-wrap">
    <img class="logo_img" alt="Logo" :src="meta.logo" :class="large && 'logo_img-large'"/>
  </div>
</template>

<style scoped>
.logo-wrap {
  text-align: center;
}
.logo_img {
  max-width: 37.87vw;
  max-height: 12vw;
  align-self: center;
  margin-top: 3.2vw;
}
.logo_img-large {
  max-width: 50.67vw;
  max-height: 14.67vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue